import React, { Component } from 'react';
import { shareFacebook, shareTwitter, shareWhatsapp, openNegishut } from "../Services/Sharing"

import "./Teaser.scss"

class Teaser extends Component {
    render() {
        return (
            <section className="section section-teaser">
                <div className="padding">
                    <div className="container">
                        <div className="headline"></div>
                        <div className="desc">
                            <span>מפת תוצאות הבחירות</span><br /><div style={{ height: 5 }}></div>
                            בערים הגדולות, ובכל יישוב ויישוב: צפו בתוצאות המתעדכנות ב-10 הערים הגדולות בישראל ולחצו בצד ימין למעלה כדי לבחון את התוצאות ביישובים הנוספים

                            <div className="vismall"></div>
                            <br/><span className="small">* המפה והתוצאות מתקבלות ממשרד הפנים</span>
                        </div>
                        <div className={`share`}>
                            <div onClick={() => { shareFacebook() }} className="facebook"></div>
                            <div onClick={() => { shareTwitter() }} className="twitter"></div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Teaser;



// WEBPACK FOOTER //
// ./src/Components/Teaser/Teaser_2.jsx